import { createAction, props } from '@ngrx/store';
import {
  IAggregatorValidationResponse,
  IAvailableScore,
  ICustomerCard,
  ICustomerValidationResponse,
  IMaxInstallmentValidationResponse,
  IUnifiedScore,
} from '../../../core/models/customer.model';
import {
  ICreateLoan,
  ICreatePreLoan,
  ICustomer,
  ICustomerValidate,
  IInstallmentsConfig,
} from '../../../core/models/customer.model';

export const requestCustomerInformation = createAction('[App] Request Customer Information');

export const successRequestCustomerInformation = createAction(
  '[Customer] Success Request Customer Information',
  props<{ customer: ICustomer }>()
);

export const failureRequestCustomerInformation = createAction(
  '[Customer] Failure Request Customer Information',
  props<{ error: string }>()
);

export const listenCustomerValidation = createAction('[Customer] Listen Customer Validation');

export const successListenCustomerValidation = createAction(
  '[Customer] Success Listen Customer Validation',
  props<{ validation: ICustomerValidationResponse }>()
);

export const failureListenCustomerValidation = createAction(
  '[Customer] Failure Listen Customer Validation',
  props<{ error: string }>()
);

export const updateLoading = createAction(
  '[Customer] Update Loading',
  props<{ isLoading: boolean }>()
);

export const requestPreLoan = createAction('[Customer] Request Pre-Loan');

export const successRequestPreLoan = createAction(
  '[Customer] Success Request Pre-Loan',
  props<{ preLoan: IInstallmentsConfig[] }>()
);

export const failureRequestPreLoan = createAction(
  '[Customer] Failure Request Pre-Loan',
  props<{ error: string }>()
);

export const createPreLoan = createAction(
  '[Customer] Create Pre Loan',
  props<{ createPreLoan: ICreatePreLoan }>()
);

export const successCreatePreLoan = createAction(
  '[Customer] Success Create Pre Loan',
  props<{ id: string }>()
);

export const updateIsLoadingPreLoan = createAction(
  '[Customer] Update Is Loading PreLoan',
  props<{ isLoadingPreLoan: boolean }>()
);

export const failureCreatePreLoan = createAction(
  '[Customer] Failure Create Pre Loan',
  props<{ error: string }>()
);

export const redirectToEcommerce = createAction(
  '[Customer] Redirect to the Ecommerce',
  props<{ portal: boolean }>()
);

export const getCustomerCard = createAction('[Customer] Get Card Information');

export const successGetCustomerCard = createAction(
  '[Customer] Success Get Card Information',
  props<{ cardInfo: ICustomerCard }>()
);

export const failureGetCustomerCard = createAction(
  '[Customer] Failure Get Card Information',
  props<{ error: string }>()
);

// DEMO

export const redirectUserToScore = createAction('[Customer] Redirect User to Score Page');

export const setCustomerInformation = createAction(
  '[Customer] Set Customer Information',
  props<{ customer: ICustomer }>()
);

export const setCustomerValidation = createAction(
  '[Customer] Set Customer Validation',
  props<{ validation: ICustomerValidationResponse }>()
);

export const checkPendingPayments = createAction(
  '[Customer] Check Pending Payments',
  props<{ route: string }>()
);

export const requestAvailableScore = createAction(
  '[Customer] Request Available Score',
  props<{ route?: string }>()
);

export const successRequestAvailableScore = createAction(
  '[Customer] Success Request Available Score',
  props<{ score: IUnifiedScore; route?: string }>()
);

export const failureRequestAvailableScore = createAction(
  '[Customer] Failure Request Available Score',
  props<{ error: string }>()
);

export const requestCustomerScore = createAction('[Customer] Request Customer Score');

export const successRequestCustomerScore = createAction(
  '[Customer] Success Request Customer Score',
  props<{ score: IUnifiedScore }>()
);

export const failureRequestCustomerScore = createAction(
  '[Customer] Failure Request Customer Score',
  props<{ error: string }>()
);

export const requestAggregatorValidation = createAction('[Customer] Request Aggregator Validation');

export const successRequestAggregatorValidation = createAction(
  '[Customer] Success Request Aggregator Validation',
  props<{ aggregatorValidation: IAggregatorValidationResponse }>()
);

export const failureRequestAggregatorValidation = createAction(
  '[Customer] Failure Request Aggregator Validation',
  props<{ error: string }>()
);

export const requestMaxInstallmentValidation = createAction(
  '[Customer] Request Max Installment Validation'
);

export const successRequestMaxInstallmentValidation = createAction(
  '[Customer] Success Request Max Installment Validation',
  props<{ maxInstallmentValidation: IMaxInstallmentValidationResponse }>()
);

export const failureRequestMaxInstallmentValidation = createAction(
  '[Customer] Failure Request Max Installment Validation',
  props<{ error: string }>()
);

export const requestDebitDecisionValidation = createAction('[Customer] Request Debit Decision');

export const successRequestDebitDecisionValidation = createAction(
  '[Customer] Success Request Debit Decision Validation',
  props<{ debitDecisionValidation }>()
);

export const failureRequestDebitDecisionValidation = createAction(
  '[Customer] Failure Request Debit Decision Validation',
  props<{ error: string }>()
);

export const validateCustomerCard = createAction(
  '[Customer] Validate Customer Card',
  props<{ cardInfo: ICustomerCard }>()
);
